import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { ProfileRequest } from '../../requests/admin-user/profile.request';
import { ListProfileResponse } from '../../responses/admin-user/list-profile.response';
import { ProfileResponse } from '../../responses/admin-user/profile.response';

@Injectable({
  providedIn: 'root'
})
export class ProfileService extends CommonService{

  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  public listProfile(searchText: string): Observable<ListProfileResponse> {
    
    let uri = 'Profile?'
    
    if(searchText != null)
    uri = uri+ `searchText=${searchText}&`;
    
    return this.httpClient.get<ListProfileResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiAdminUser) + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }

  public getProfileRoles(idProfile: number): Observable<ProfileResponse> {
    
    let uri = `Profile/idProfile/${idProfile}`;
    
    return this.httpClient.get<ProfileResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiAdminUser) + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }


  public listAllProfile():  Observable<ListProfileResponse>{

    let uri = `Profile/getAll`;

    return this.httpClient.get<ListProfileResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiAdminUser) + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }

  public createProfileRoles(body: ProfileRequest): Observable<ProfileResponse> {
    
    let uri = `Profile`;
    
    return this.httpClient.post<ProfileResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiAdminUser) + uri, body, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }

  public editProfileRoles(idProfile: number, body: ProfileRequest): Observable<ProfileResponse> {
    
    let uri = `Profile/idProfile/${idProfile}`;
    
    return this.httpClient.put<ProfileResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiAdminUser) + uri, body, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }

  public deleteProfile(idProfile: number): Observable<ReturnStruct>{
    return this.httpClient.delete<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiAdminUser) + `Profile/idProfile/${idProfile}`, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }
}
